export default [
  { label: '1st', value: '1st' },
  { label: '2nd', value: '2nd' },
  { label: '3rd', value: '3rd' },
  { label: '4th', value: '4th' },
  { label: '5th', value: '5th' },
  { label: '6th', value: '6th' },
  { label: '7th', value: '7th' },
  { label: '8th', value: '8th' },
  { label: '9th', value: '9th' },
  { label: '10th', value: '10th' },
  { label: '11th', value: '11th' },
  { label: '12th', value: '12th' },
  { label: '13th', value: '13th' },
  { label: '14th', value: '14th' },
  { label: '15th', value: '15th' },
  { label: '16th', value: '16th' },
  { label: '17th', value: '17th' },
  { label: '18th', value: '18th' },
  { label: '19th', value: '19th' },
  { label: '20th', value: '20th' },
  { label: '21st', value: '21st' },
  { label: '22nd', value: '22nd' },
  { label: '23rd', value: '23rd' },
  { label: '24th', value: '24th' },
  { label: '25th', value: '25th' },
  { label: '26th', value: '26th' },
  { label: '27th', value: '27th' },
  { label: '28th', value: '28th' },
  { label: '29th', value: '29th' },
  { label: '30th', value: '30th' },
  { label: '31st', value: '31st' },
  { label: '32nd', value: '32nd' },
  { label: '33rd', value: '33rd' },
  { label: '34th', value: '34th' },
  { label: '35th', value: '35th' },
  { label: '36th', value: '36th' }
]
